import React from 'react';
import Editor from '@monaco-editor/react';
import { useEditor } from '../context/EditorProvider.jsx';

export default function EditorPane() {
  const { state, dispatch } = useEditor();
  
  const active = state.files.find((f) => f.id === state.activeFileId) || state.files[0];

  if (!active) return <div style={{ flex: 1 }}>No file open</div>;

  return (
    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', position: 'relative' }}>
      <Editor
        key={active.id}
        path={active.filename}
        width="100%"
        height="100%"
        language="java"
        theme="light"
        value={active.content}
        onChange={(v) => dispatch({ type: 'UPDATE_CONTENT', id: active.id, content: v })}
        options={{ fontSize: 14, minimap: { enabled: false } }}
      />
    </div>
  );
} 